import { Skeleton } from '../../../../feedback/Skeleton';
import { Box } from '../../../../layout/Box';
import { CampaignCard } from '../CampaignCard/CampaignCard';
import { ContentPromotionStart } from '../ContentPromotionStart/ContentPromotionStart';
import { ContentPromotionDetailsProps } from './types';

export const ContentPromotionDetails: React.FC<ContentPromotionDetailsProps> = ({
    directCompanies,
    isLoading,
}) => {
    if (isLoading) {
        return (
            <Box>
                <Skeleton mb={0.5} variant="text" width="80%" height={18} />
                <Skeleton mb={2.5} variant="text" width="80%" height={18} />
            </Box>
        );
    }

    if (!directCompanies?.length) {
        return <ContentPromotionStart />;
    }

    const campaign = directCompanies[0];

    return <CampaignCard key={campaign.name} campaign={campaign} />;
};
